/* eslint-disable no-unsafe-optional-chaining */
'use client'
import MyImage from '@/shared/components/myImage';
import { getImgURL } from '@/shared/utils';
import React from 'react'

function TeamComparison({recentMatchesData}: any) {

  const team1 = recentMatchesData[0]
  const team2 = recentMatchesData[1]
  
  return (
    <div className='mb-6'>
    <p className='text-base font-medium text-textOffWhite mb-5 md:mb-6'>
    Team Comparison <span className='text-sm md:text-base font-medium text-TextScoredCompplete'>  (Last {recentMatchesData[0]?.nTotalMatches} matches)</span>
    </p>
    <div className='flex items-center justify-between gap-3 pb-4 md:pb-[25px]'>
      <div className=' flex items-center gap-2'>
        <MyImage src={getImgURL(team1?.oTeam?.oImg?.sUrl)} height={35} width={35} className=' md:w-9 w-[30px] h-[30px] md:h-9 flex-shrink-0 rounded-full object-cover'/>
        <div>
          <p className='text-sm md:text-base font-bold text-textOffWhite'>{team1?.oTeam?.sAbbr}</p>
          <p className='text-xs md:text-sm font-medium text-TextScoredCompplete'>vs all teams</p>
        </div>
      </div>
      <div className=' flex items-center gap-2 text-right'>
        <div>
          <p className='text-sm md:text-base font-bold text-textOffWhite'>{team2?.oTeam?.sAbbr}</p>
          <p className='text-xs md:text-sm font-medium text-TextScoredCompplete'>vs all teams</p>
        </div>
        <MyImage src={getImgURL(team2?.oTeam?.oImg?.sUrl)} height={35} width={35} className=' md:w-9 w-[30px] h-[30px] md:h-9 flex-shrink-0 rounded-full object-cover'/>
      </div>
    </div>
    <div className='flex items-center justify-between gap-3 py-3 md:px-5 px-0 border-y border-borderStroke'>
      <p className='text-sm md:text-base text-textOffWhite font-medium'>{team1?.nTotalMatches}</p>
      <p className='text-sm font-bold text-TextScoredCompplete'>Matches Played</p>
      <p className='text-sm md:text-base text-textOffWhite font-medium'>{team2?.nTotalMatches}</p>
    </div>
    <div className='flex items-center justify-between gap-3 py-3 md:px-5 px-0 border-y border-borderStroke'>
      <p className={`text-sm md:text-base ${team1?.nTotalWinsPer > team2?.nTotalWinsPer ? 'text-winBg' : 'text-lossBg'} font-medium`}>{(team1?.nTotalWinsPer).toFixed(2)}%</p>
      <p className='text-sm font-bold text-TextScoredCompplete'>Win %</p>
      <p className={`text-sm md:text-base ${team2?.nTotalWinsPer > team1?.nTotalWinsPer ? 'text-winBg' : 'text-lossBg'} font-medium`}>{(team2?.nTotalWinsPer).toFixed(2)}%</p>
    </div>
    <div className='flex items-center justify-between gap-3 py-3 md:px-5 px-0 border-y border-borderStroke'>
      <p className={`text-sm md:text-base ${team1?.nAverageScore > team2?.nAverageScore ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team1?.nAverageScore}</p>
      <p className='text-sm font-bold text-TextScoredCompplete'>Average Score</p>
      <p className={`text-sm md:text-base ${team2?.nAverageScore > team1?.nAverageScore ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team2?.nAverageScore}</p>
    </div>
    <div className='flex items-center justify-between gap-3 py-3 md:px-5 px-0 border-y border-borderStroke'>
      <p className={`text-sm md:text-base ${team1?.nHighestScore?.nRuns > team2?.nHighestScore?.nRuns ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team1?.nHighestScore?.nRuns}</p>
      <p className='text-sm font-bold text-TextScoredCompplete'>Highest Score</p>
      <p className={`text-sm md:text-base ${team2?.nHighestScore?.nRuns > team1?.nHighestScore?.nRuns ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team2?.nHighestScore?.nRuns}</p>
    </div>
    <div className='flex items-center justify-between gap-3 py-3 md:px-5 px-0 border-y border-borderStroke'>
      <p className={`text-sm md:text-base ${team1?.nLowestScore?.nRuns > team2?.nLowestScore?.nRuns ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team1?.nLowestScore?.nRuns}</p>
      <p className='text-sm font-bold text-TextScoredCompplete'>Lowest Score</p>
      <p className={`text-sm md:text-base ${team2?.nLowestScore?.nRuns > team1?.nLowestScore?.nRuns ? 'text-winBg' : 'text-lossBg'} font-medium`}>{team2?.nLowestScore?.nRuns}</p>
    </div>
</div>
  )
}

export default TeamComparison
